/**
 * 官方文档
 * https://echarts.apache.org/zh/option.html#tooltip.axisPointer.snap
 * 按需引入：https://github.com/apache/incubator-echarts/blob/master/index.js
 */
//  引入国际化
// import VueI18n from 'vue-i18n'
// Vue.use(VueI18n)
// const i18n = new VueI18n({
//     locale: getLang(),  // 语言标识
//     messages: {
//         'zh': require('./plugins/lang/zh-cn'),
//         'en': require('./plugins/lang/en-us')
//     }
// })
//引入基本模板
var echarts = require('echarts/lib/echarts')
// 引入折线图等组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/radar')
require('echarts/lib/chart/candlestick')
// 引入提示框和title组件，图例,注释
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/dataZoom')
require("echarts/lib/component/legendScroll")
require('echarts/lib/component/legend')

// 引入方法
// #00aa3b 绿色；#F9293E 红色
// 数字货币：绿色是涨，红色是跌
// 期货则相反
var bgColor = "#1f212d";//背景   1f212d
// var upColor="#F9293E";//涨颜色
// var downColor="#00aa3b";//跌颜色
var borderColor = "#515151";//边框颜色

// ma  颜色
var ma5Color = "#39afe6";
var ma10Color = "#da6ee8";
var ma20Color = "#ffab42";
var ma30Color = "#00940b";

// 定义
var mChart, // 分时init对象
	mOption, // 分时参数
	mData, // 分时数据
	kChart, // k线init对象
	kOption, // k线参数
	kData; // k线数据
// 定义dataZoom位置
var dataZoom_m_start,
	dataZoom_m_end,
	dataZoom_k_start,
	dataZoom_k_end;

var zmath = {
	//加
	add:function(a,b){
		let c, d, e;
	    try {
	        c = a.toString().split(".")[1].length;
	    } catch (f) {
	        c = 0;
	    }
	    try {
	        d = b.toString().split(".")[1].length;
	    } catch (f) {
	        d = 0;
	    }
	    return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) + this.mul(b, e)) / e;
	},
	//减
	sub:function (a,b) {
		let c, d, e;
	    try {
	        c = a.toString().split(".")[1].length;
	    } catch (f) {
	        c = 0;
	    }
	    try {
	        d = b.toString().split(".")[1].length;
	    } catch (f) {
	        d = 0;
	    }
	    return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) - this.mul(b, e)) / e;
	},
	//乘
	mul:function (a,b) {
		let c = 0,
	        d = a.toString(),
	        e = b.toString();
	    try {
	        c += d.split(".")[1].length;
	    } catch (f) {}
	    try {
	        c += e.split(".")[1].length;
	    } catch (f) {}
	    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
	},
	//除
	div:function (a,b) {
		let c, d, e = 0,
	        f = 0;
	    try {
	        e = a.toString().split(".")[1].length;
	    } catch (g) {}
	    try {
	        f = b.toString().split(".")[1].length;
	    } catch (g) {}
	    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.mul(c / d, Math.pow(10, f - e));
	},
};
/**
 * 15:20 时:分 格式时间增加num分钟
 * @param {Object} time 起始时间
 * @param {Object} num
 */
function addTimeStr(time,num){
	var hour=time.split(':')[0];
	var mins=Number(time.split(':')[1]);
	var mins_un=parseInt((mins+num)/60);
	var hour_un=parseInt((Number(hour)+mins_un)/24);
	if(mins_un>0){
		if(hour_un>0){
			var tmpVal=((Number(hour)+mins_un)%24)+"";
			hour=tmpVal.length>1? tmpVal:'0'+tmpVal;//判断是否是一位
		}else{
			var tmpVal=Number(hour)+mins_un+"";
			hour=tmpVal.length>1? tmpVal:'0'+tmpVal;
		}
		var tmpMinsVal=((mins+num)%60)+"";
		mins=tmpMinsVal.length>1? tmpMinsVal:0+tmpMinsVal;//分钟数为 取余60的数
	}else{
		var tmpMinsVal=mins+num+"";
		mins=tmpMinsVal.length>1? tmpMinsVal:'0'+tmpMinsVal;//不大于整除60
	}
	return hour+":"+mins;
}

//获取增加指定分钟数的 数组  如 09:30增加2分钟  结果为 ['09:31','09:32']
function getNextTime(startTime, endTIme, offset, resultArr) {
	var result = addTimeStr(startTime, offset);
	resultArr.push(result);
	if (result == endTIme) {
		return resultArr;
	} else {
		return getNextTime(result, endTIme, offset, resultArr);
	}
}



/**
 * 不同类型的股票的交易时间会不同
 * @param {Object} type   hs=沪深  us=美股  hk=港股
 */
var time_arr = function(type) {
	if(type.indexOf('us')!=-1){//生成美股时间段
		var timeArr = new Array();
		timeArr.push('09:30')
		return getNextTime('09:30', '16:00', 1, timeArr);
	}
	if(type.indexOf('hs')!=-1){//生成沪深时间段
		var timeArr = new Array();
			timeArr.push('09:30');
			timeArr.concat(getNextTime('09:30', '11:29', 1, timeArr));
			timeArr.push('13:00');
			timeArr.concat(getNextTime('13:00', '15:00', 1, timeArr));
		return timeArr;
	}
	if(type.indexOf('hk')!=-1){//生成港股时间段
		var timeArr = new Array();
			timeArr.push('09:30');
			timeArr.concat(getNextTime('09:30', '11:59', 1, timeArr));
			timeArr.push('13:00');
			timeArr.concat(getNextTime('13:00', '16:00', 1, timeArr));
		return timeArr;
	}

}


var get_m_data = function(m_data) {
	var priceArr = new Array();
	var avgPrice = new Array();
	var vol = new Array();
	var scope = m_data.scope;
	var timeArr = new Array();
	m_data.data.forEach(function(v,i) {
		timeArr.push(v[0])
		priceArr.push(v[1]);
		avgPrice.push(v[2]);
		vol.push(v[3]);
	})
	var nextIndex = m_data.data.length
	var lastTime = m_data.data[nextIndex - 1][0];//数据列表里面最后一条的时间
	// console.log(JSON.stringify(timeArr))
	// console.log(JSON.stringify(vol))
	// var times = getNextTime(lastTime, scope[1], 1, timeArr);
	return {
		priceArr: priceArr,
		avgPrice: avgPrice,
		vol: vol,
		// times: times
		times: timeArr
	}
}



//==========================================分时表 option

/**
 * 生成分时option
 * @param {Object} m_data 分时数据
 * @param {Object} type 股票类型  us-美股  hs-沪深  hk-港股
 */
function initMOption(vue,m_data){
	// 涨跌颜色
	var upColor = vue.kStyle.up.color;
	var downColor = vue.kStyle.down.color;
	var m_datas = get_m_data(m_data);
	return {
		tooltip: { //弹框指示器
			trigger: 'axis',
			axisPointer: {
				type: 'cross',//指示器：只显示y轴值line x和y轴值都显示cross
				label:{
					show:false
				}
			},
			position: function (pos, params, el, elRect, size) {
                var obj = {top: 10};
                obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 10;
                return obj;
            },
			formatter: function(params, ticket, callback) {
				var i = params[0].dataIndex;
				var color;
				if (m_datas.priceArr[i] > m_data.yestclose) {
					color ='style="color:#ff4242"';
				} else {
					color ='style="color:#26bf66"';
				}
				var html = '<div class="commColor" style="width:auto;">'+params[0].name+'<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fff;"></span>'+vue.$t('最新价')+'：<span  '+color+' >' + m_datas.priceArr[i] + '</span></div>';
				// html += '<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:yellow;"></span>'+vue.$t('均价')+'：<span  '+color+' >' + m_datas.avgPrice[i] + '</span></div>';
				html += '<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#ffab42;"></span>'+vue.$t('涨幅')+'：<span  '+color+' >' + ratioCalculate(m_datas.priceArr[i],m_data.yestclose)+ '%</span></div>';
				html += '<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00940b;"></span>'+vue.$t('成交量')+'：<span  '+color+' >' + m_datas.vol[i] + '</span></div></div>'
				return html;
			}
		},
		color: [ma5Color, ma10Color],
		grid: [
			{
				id: 'gd1',
				left: '5%',
				right: '5%',
				height: '50%', //主K线的高度,67.5
				top: '20%',
			},
			{
				id: 'gd2',
				left: '5%',
				right: '5%',
				height: '50%', //主K线的高度,
				top: '20%'
			},
			{
				id: 'gd3',
				left: '5%',
				right: '5%',
				top: '70%',//82
				height: '20%' //交易量图的高度
			}
		],
		xAxis: [ //==== x轴
			{ //主图
				gridIndex: 0,
				data: m_datas.times,
				boundaryGap : false,
				axisLabel: { //label文字设置，！！特别注意，不要指定字体大小，否则线不会对齐！！
					show: false
				},
		        axisLine: { //最外边框线
		            show: true, // Y轴线
		            lineStyle: {
		                type: 'solid',
		                color: borderColor
		            }
		        },
				splitLine: { //分割线设置
					show: false,
					lineStyle: {
						color: borderColor,
						type:'solid',
						width:0.5
					}
				},
				min: 'dataMin',
				max: 'dataMax'
			},
			{
				show:false,
				gridIndex: 1,
				data: m_datas.times,
				boundaryGap : false,
				axisLabel: { //label文字设置，！！特别注意，不要指定字体大小，否则线不会对齐！！
					show: false
				},
		        axisLine: { //最外边框线
		            show: true, // Y轴线
		            lineStyle: {
		                type: 'solid',
		                color: borderColor
		            }
		        },
				splitLine: { //分割线设置
					show: false
				},
			},
			{ //交易量图

				// type: 'category',
				// splitNumber: 2,
				gridIndex: 2,
				data: m_datas.times,
				boundaryGap : false,
				axisLabel: { //label文字设置，！！特别注意，不要指定字体大小，否则线不会对齐！！
					show: true,
					color: '#9b9da9',
					// fontSize: 10
				},
		        axisLine: {
		            show: true, // Y轴线
		            lineStyle: {
		                type: 'solid',
		                color: borderColor
		            }
		        },
				splitLine: { //分割线设置
					show: false,
					lineStyle: {
						color: borderColor,
						type:'solid',
						width:0.5
					}
				},
				min: 'dataMin',
				max: 'dataMax'
			}
		],
		yAxis: [ //y轴
			{
				gridIndex: 0,
				scale: true,
				splitNumber: 2,
				axisLabel: { //label文字设置
					inside: true, //label文字朝内对齐
					showMinLabel:false,// 是否显示最小 tick 的 label
					// fontWeight:'bold',
					color:function(val){
						if(val==m_data.yestclose){
							return '#aaa'
						}
						return val>m_data.yestclose? upColor:downColor;
					}
				},
		        axisLine: { //最外边框线
		            show: true, // Y轴线
		            lineStyle: {
		                type: 'solid',
		                color: borderColor
		            }
		        },
				z:0, // 分割线置底
				splitLine: { //分割线设置
					show: false,
					lineStyle: {
						color: borderColor,
						type:'solid',
						width:0.5
					}
				},
			},
			{
				scale: true,
				gridIndex: 1,
				splitNumber: 2,
				position: 'right',
				z:0,
				axisLabel: { //label文字设置
					color:function(val){
						if(val==m_data.yestclose){
							return '#aaa'
						}
						return val>m_data.yestclose? upColor:downColor;
					},
					inside: true, //label文字朝内对齐
					showMinLabel:false,// 是否显示最小 tick 的 label
					// fontWeight:'bold',
					formatter:function(val){
						var resul=ratioCalculate(val,m_data.yestclose);
						return  Number(resul).toFixed(2)+' %'}
				},
		        axisLine: { //最外边框线
		            show: true, // Y轴线
		            lineStyle: {
		                type: 'solid',
		                color: borderColor
		            }
		        },
				splitLine: { //分割线设置
					show: false,
					lineStyle: {
						color: borderColor
					}
				},
				axisPointer:{
					show:true,
					label:{
						formatter:function(params){ //计算右边Y轴对应的当前价的涨幅比例
							return  ratioCalculate(params.value,m_data.yestclose)+'%';
						}
					}
				}
			},
			{ //交易图
				gridIndex: 2,
				scale: true, // 设置成 true 后坐标刻度不会强制包含零刻度
				z:0, // 分割线置底
				splitNumber: 2,
		        axisLine: { //最外边框线
		            show: true, // Y轴线
		            lineStyle: {
		                type: 'solid',
		                color: borderColor
		            }
		        },
				axisTick: {
					show: false
				},
				splitLine: { //分割线设置
					show: false,
					lineStyle: {
						color: borderColor,//
						type:'solid',
						width:0.5
					}
				},
				axisLabel: { //label文字设置
					color: '#c7c7c7',
					inside: true, //label文字朝内对齐
					showMinLabel:false,// 是否显示最小 tick 的 label
					// fontSize: 8
				},
			}
		],
		dataZoom: [{
				type: 'slider',
				xAxisIndex: [0, 1, 2], //控件联动
				start: 90,
				end: 100,
				minSpan:10,
				maxSpan:10,
				throttle: 10,
				top: '5%',
				height: '5%',
				borderColor: '#696969',
				textStyle: {
					color: '#000'
				},
				handleSize: '100%', //滑块图标
				handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
				dataBackground: {
					lineStyle: {
						color: '#fff'
					}, //数据边界线样式
					areaStyle: {
						color: '#696969'
					} //数据域填充样式
				}
			},
		],
	    axisPointer: {  //控件联动
	        link: {
	        	xAxisIndex: 'all'
	        },
	        label: {
	            backgroundColor: '#777'
	        }
	    },
		animation:false,//禁止动画效果
		backgroundColor: bgColor,
		blendMode: 'source-over',
		series: [
			{ //最新价
				name: '最新价',
				type: 'line',
				data: m_datas.priceArr,
				smooth: true,
				symbol: "circle", //中时有小圆点
				gridIndex: 0,
				xAxisIndex: 0,
				yAxisIndex: 0,
				lineStyle: {
					normal: {
						opacity: 0.8,
						color: '#365AE1',//#39afe6 #365AE1
						width: 0.5
					}
				},

				areaStyle: { //这是分时区域渐变效果
					normal: {
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
							offset: 0,
							color: 'rgba(0, 136, 212, 0.7)'
						}, {
							offset: 0.8,
							color: 'rgba(0, 136, 212, 0.02)'
						}], false),
						shadowColor: 'rgba(0, 0, 0, 0.1)',
						shadowBlur: 10
					}
				}
			},
			// {  //均线
			// 	name: '均价',
			// 	type: 'line',
			// 	data: m_datas.avgPrice,
			// 	smooth: true,
			// 	symbol: "circle",
			// 	lineStyle: { //标线的样式
			// 		normal: {
			// 			opacity: 0.8,
			// 			color: '#D4B471',//分时线颜色：yellow #008fff  #D4B471
			// 			width: 1
			// 		}
			// 	}
			// },
			{ //y轴 右边
				type: 'line',
				data: m_datas.priceArr,
				smooth: true,
				symbol: "none",
				gridIndex: 1,
				xAxisIndex: 1,
				yAxisIndex: 1,
				lineStyle: { //标线的样式
					normal: {
						width: 0
					}
				}
			},
			{
				name: '成交量', //Volumn
				type: 'bar',
				gridIndex: 2,
				xAxisIndex: 2,
				yAxisIndex: 2,
				data: m_datas.vol,
				itemStyle: {
					normal: {
						color: function(params) {
							var colorList;
							if (m_datas.priceArr[params.dataIndex] > m_datas.priceArr[params.dataIndex-1]) {
								colorList = upColor;
							} else {
								colorList = downColor;
							}
							return colorList;
						},
					}
				}
			}
		]
	};
}



/**
 * 计算价格涨跌幅百分比
 * @param {Object} price 当前价
 * @param {Object} yclose 昨收价
 */
function ratioCalculate(price,yclose){
	return ((price-yclose)/yclose*100).toFixed(3);
}

//数组处理
function splitData(rawData) {
	var datas = []; var times = [];var vols = [];
	for (var i = 0; i < rawData.length; i++) {
		datas.push(rawData[i]);
		times.push(rawData[i].splice(0, 1)[0]);
		vols.push(rawData[i][4]);
	}
	return {datas:datas,times:times,vols:vols};
}


//================================MA计算公式
function calculateMA(dayCount,data) {
	var result = [];
	for (var i = 0, len = data.times.length; i < len; i++) {
		if (i < dayCount) {
			result.push('-');
			continue;
		}
		var sum = 0;
		for (var j = 0; j < dayCount; j++) {
			sum = zmath.add(sum,data.datas[i - j][2])
		}
		result.push((sum / dayCount).toFixed(3));
	}
	return result;
}


//=================================================MADC计算公式

var calcEMA,calcDIF,calcDEA,calcMACD;

/*
 * 计算EMA指数平滑移动平均线，用于MACD
 * @param {number} n 时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcEMA=function(n,data,field){
    var i,l,ema,a;
    a=2/(n+1);
    if(field){
        //二维数组
        ema=[data[0][field]];
        for(i=1,l=data.length;i<l;i++){
            ema.push((a*data[i][field]+(1-a)*ema[i-1]).toFixed(6));
        }
    }else{
        //普通一维数组
        ema=[data[0]];
        for(i=1,l=data.length;i<l;i++){
            ema.push((a*data[i]+(1-a)*ema[i-1]).toFixed(6) );
        }
    }
    return ema;
};

/*
 * 计算DIF快线，用于MACD
 * @param {number} short 快速EMA时间窗口
 * @param {number} long 慢速EMA时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcDIF=function(short,long,data,field){
    var i,l,dif,emaShort,emaLong;
    dif=[];
    emaShort=calcEMA(short,data,field);
    emaLong=calcEMA(long,data,field);
    // console.log('emaShort=')
    // console.log(emaShort)
    // console.log('emaLong=')
    // console.log(emaLong)
    for(i=0,l=data.length;i<l;i++){
        dif.push((emaShort[i]-emaLong[i]).toFixed(6));
    }
    return dif;
};

/*
 * 计算DEA慢线，用于MACD
 * @param {number} mid 对dif的时间窗口
 * @param {array} dif 输入数据
 */
calcDEA=function(mid,dif){
    return calcEMA(mid,dif);
};

/*
 * 计算MACD
 * @param {number} short 快速EMA时间窗口
 * @param {number} long 慢速EMA时间窗口
 * @param {number} mid dea时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcMACD=function(short,long,mid,data,field){
    var i,l,dif,dea,macd,result;
    result={};
    macd=[];
    dif=calcDIF(short,long,data,field);
    dea=calcDEA(mid,dif);
    for(i=0,l=data.length;i<l;i++){

        macd.push(((dif[i]-dea[i])*2).toFixed(6));
    }
    result.dif=dif;
    result.dea=dea;
    result.macd=macd;
    return result;
};


 //=================================================MADC计算公式 end




 //=================================================K线参数
function initKOption(vue,cdata){
	// 涨跌颜色
	var upColor = vue.kStyle.up.color;
	var downColor = vue.kStyle.down.color;
	// k线数据复杂
	kData = cdata
	// 定义
	var data = splitData(cdata),
		macd = calcMACD(12,26,9,data.datas,1),
		ma5 = calculateMA(5,data),
		ma10 = calculateMA(10,data),
		ma20 = calculateMA(20,data),
		ma30 = calculateMA(30,data);

		// 设置日均值
		document.getElementById("k-ma5").innerHTML = ma5[ma5.length-1];
		document.getElementById("k-ma10").innerHTML = ma10[ma10.length-1];
		document.getElementById("k-ma20").innerHTML = ma20[ma20.length-1];
		document.getElementById("k-ma30").innerHTML = ma30[ma30.length-1];
	return {
			tooltip: { //弹框指示器
				show:false,
				trigger: 'axis', // item  axis
				axisPointer: {
					type: 'cross',//指示器：只显示y轴值line x和y轴值都显示cross
					label:{
						show:false
					}
				},
				position: function (pos, params, el, elRect, size) {
	                var obj = {top: 10};
	                obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 10;
	                return obj;
	            },
				formatter: function(params, ticket, callback) {
					if (params[0].axisIndex==0) { //K线
						var k = params[0],
						kv = k.value,
						ma5 = params[1],
						ma10 = params[2],
						ma20 = params[3],
						ma30 = params[4],
						dian = '<span style="display:inline-block;margin-right:5px;border-radius:5px;width:5px;height:5px;background-color:#F9293E;"></span>';

						var kpj = vue.$t('开盘价');
						var spj = vue.$t('收盘价');
						var zdj = vue.$t('最低价');
						var zgj = vue.$t('最高价');
						var cjl = vue.$t('成交量');
						var html = `<div>
						${k.name}<br>
						${k.marker}${k.seriesName}<br>
						${dian}${kpj}：${kv[1]}<br>
						${dian}${spj}：${kv[2]}<br>
						${dian}${zdj}：${kv[3]}<br>
						${dian}${zgj}：${kv[4]}<br>
						${dian}${cjl}：${kv[5]}
						</div>`;
						// <br>
						// ${ma5.marker}${ma5.seriesName}：${ma5.value}<br>
						// ${ma10.marker}${ma10.seriesName}：${ma10.value}<br>
						// ${ma20.marker}${ma20.seriesName}：${ma20.value}<br>
						// ${ma30.marker}${ma30.seriesName}：${ma30.value}
						// 设置日均值
						document.getElementById("k-ma5").innerHTML = ma5.value;
						document.getElementById("k-ma10").innerHTML = ma10.value;
						document.getElementById("k-ma20").innerHTML = ma20.value;
						document.getElementById("k-ma30").innerHTML = ma30.value;
					}
					else if (params[0].axisIndex==1) { //成交量
						var k = params[0];
						var html = `<div>
						${k.name}<br>
						${k.marker}${k.seriesName}：${k.value}
						</div>`;
					}
					else if (params[0].axisIndex==2) { //其他
						var k = params[0],
						k1 = params[1],
						k2 = params[2];
						var html = `<div>
						${k.name}<br>
						${k.marker}${k.seriesName}：${k.value}<br>
						${k1.marker}${k1.seriesName}：${k1.value}<br>
						${k2.marker}${k2.seriesName}：${k2.value}<br>
						</div>`;
					}
					return html
				}
			},
			// legend: { //图例控件,点击图例控制哪些系列不显示
			// 	icon: 'rect',
			// 	type:'scroll',
			// 	itemWidth: 10,
			// 	itemHeight: 2,
			// 	left: 0,
			// 	top: '0%',
			// 	animation:true,
			// 	textStyle: {
			// 		fontSize: 12,
			// 		color: '#0e99e2'
			// 	},
			// 	pageIconColor:'#0e99e2'
			// },
			color: [ma5Color, ma10Color, ma20Color, ma30Color],
			grid: [{
				id: 'gd1',
				left: '2%',
				right: '8%',
				top: '4%',//10
				height: '50%', //主K线的高度,
			}, {
				left: '2%',
				right: '8%',
				top: '54%',//66
				height: '12%' //交易量图的高度
			}, {
				left: '2%',
				right: '8%',
				top: '66%', //80
				height: '16%' //MACD 指标
			}],
			xAxis: [ //==== x轴
				{ //主图
					type: 'category',
					data: data.times,
					// scale: true,
					// boundaryGap: false,
					// axisLine: {
					// 	onZero: false
					// },
					axisLabel: { //label文字设置
						show: false
					},
			        axisLine: { //最外边框线
			              show: true, // Y轴线
			              lineStyle: {
			                  type: 'solid',
			                  color: borderColor
			              }
			        },
					splitLine: { //分割线设置
						show: false,
						lineStyle: {
							color: '#515151',
							type:'solid',
							width:0.5
						}
					},
					min: 'dataMin',
					max: 'dataMax'
				},{ //交易量图
					type: 'category',
					gridIndex: 1,
					data: data.times,
					axisLabel: {
						show: false
					},
		          	axisLine: { //最外边框线
			            show: true, // Y轴线
			            lineStyle: {
			                type: 'solid',
			                color: borderColor
			            }
		          	},
					splitLine: { //分割线设置
						show: false,
						lineStyle: {
							color: '#f8f8f8',
							type:'solid',
							width:0.5
						}
					},
				},{ //幅图
					type: 'category',
					gridIndex: 2,
					data: data.times,
					axisLabel: { //label文字设置
						color: '#9b9da9',
						fontSize: 10
					},
					axisLine: { //最外边框线
						show: true, // Y轴线
						lineStyle: {
							type: 'solid',
							color: borderColor
						}
					},
					splitLine: { //分割线设置
						show: false,
						lineStyle: {
							color: '#f8f8f8',
							type:'solid',
							width:0.5
						}
					},
				}
			],
			yAxis: [ //y轴
				{ //==主图
					scale: true,
					z:0, // 分割线置底
					axisLabel: { //label文字设置
						color: '#c7c7c7',
						inside: true, //label文字朝内对齐
						showMinLabel:false,// 是否显示最小 tick 的 label
					},
					axisLine: {
						show: true, // Y轴线
						lineStyle: {
							type: 'solid',
							color: borderColor
						}
					},
					splitNumber:4,// 分割线间隔
					splitLine: { //分割线设置
						show: false,
						lineStyle: {
							color: '#f8f8f8',//626578
							type:'solid',
							width:1,
							opacity:1
						}
					}
				},{ //交易图
					gridIndex: 1,
					z:0, // 分割线置底
					axisLine: {
						onZero: false
					},
					axisTick: {
						show: false
					},
					/*splitLine: {
						show: false
					},*/
					splitNumber:1,// 分割线间隔
					splitLine: { //分割线设置
						show: false,
						lineStyle: {
							color: borderColor,
							type:'solid',
							width:0.5,
							opacity:0.6
						}
					},
					axisLabel: { //label文字设置
						color: '#c7c7c7',
						inside: true, //label文字朝内对齐
						showMinLabel:false,// 是否显示最小 tick 的 label
					},
					axisLine: {
						show: true, // Y轴线
						lineStyle: {
							type: 'solid',
							color: borderColor
						}
					}
				},{ //幅图
					z:0, // 分割线置底
					gridIndex: 2,
					splitNumber: 1,
					axisTick: {
						show: false
					},
					splitLine: { //分割线设置
						show: false,
						lineStyle: {
							color: '#f8f8f8',
							type:'solid',
							width:0.5,
							opacity:0.6
						}
					},
					axisLabel: { //label文字设置
						color: '#c7c7c7',
						inside: true, //label文字朝内对齐
						showMinLabel:false,// 是否显示最小 tick 的 label
					},
					axisLine: { //最外边框线
						onZero: false,
						show: true, // Y轴线
						lineStyle: {
							type: 'solid',
							color: borderColor
						}
					},
				}
			],
			dataZoom: [{
				type: 'inside',//电脑端：slider  手机端：inside
				xAxisIndex: [0, 1, 2], //控件联动
				start: 70,// 90%
				end: 100, // 100%
				throttle: 10,
				top: '94%',//94%
				height: '6%',
				borderColor: borderColor,
				textStyle: {
					color: '#dcdcdc'
				},
				handleSize: '90%', //滑块图标
				handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
				dataBackground: {
					lineStyle: {
						color: borderColor
					}, //数据边界线样式
					areaStyle: {
						color: borderColor
					} //数据域填充样式
				}
			}],
			axisPointer: {  //控件联动
	            link: {
	            	xAxisIndex: 'all'
	            },
	            label: {
	                backgroundColor: '#777'
	            }
	        },
			animation: false, //禁止动画效果
			backgroundColor: bgColor,
			blendMode: 'source-over',
			series: [{
					name: vue.$t('K线周期图表'),
					type: 'candlestick',
					data: data.datas,
					barWidth: '55%',
					large: true,
					largeThreshold: 100,
					itemStyle: {
						normal: {
							color: upColor, //fd2e2e  ff4242
							color0: downColor,
							borderColor: upColor,
							borderColor0: downColor,

							//opacity:0.8
						}
					},
				},{
					name: 'MA5',
					type: 'line',
					data: ma5,
					smooth: true,
					symbol: "none", //隐藏选中时有小圆点
					lineStyle: {
						normal: {
							opacity: 0.8,
							color: '#39afe6',
							width: 1
						}
					},
				},{
					name: 'MA10',
					type: 'line',
					data: ma10,
					smooth: true,
					symbol: "none",
					lineStyle: { //标线的样式
						normal: {
							opacity: 0.8,
							color: '#da6ee8',
							width: 1
						}
					}
				},{
					name: 'MA20',
					type: 'line',
					data: ma20,
					smooth: true,
					symbol: "none",
					lineStyle: {
						opacity: 0.8,
						width: 1,
						color: ma20Color
					}
				},{
					name: 'MA30',
					type: 'line',
					data: ma30,
					smooth: true,
					symbol: "none",
					lineStyle: {
						normal: {
							opacity: 0.8,
							width: 1,
							color: ma30Color
						}
					}
				},{
					name: vue.$t('成交量'),
					type: 'bar',
					xAxisIndex: 1,
					yAxisIndex: 1,
					data: data.vols,
					barWidth: '60%',
					itemStyle: {
						normal: {
							color: function(params) {
								var colorList;
								if (data.datas[params.dataIndex][1] > data.datas[params.dataIndex][0]) {
									colorList = upColor;
								} else {
									colorList = downColor;
								}
								return colorList;
							},
						}
					}
				},{
					name: 'MACD',
					type: 'bar',
					xAxisIndex: 2,
					yAxisIndex: 2,
					data: macd.macd,
					barWidth: '40%',
					itemStyle: {
						normal: {
							color: function(params) {
								var colorList;
								if (params.data >= 0) {
									colorList = upColor;
								} else {
									colorList = downColor;
								}
								return colorList;
							},
						}
					}
				},{
					name: 'DIF',
					type: 'line',
					symbol: "none",
					xAxisIndex: 2,
					yAxisIndex: 2,
					data: macd.dif,
					lineStyle: {
						normal: {
							color: '#da6ee8',
							width: 1
						}
					}
				},{
					name: 'DEA',
					type: 'line',
					symbol: "none",
					xAxisIndex: 2,
					yAxisIndex: 2,
					data: macd.dea,
					lineStyle: {
						normal: {
							opacity: 0.8,
							color: '#39afe6',
							width: 1
						}
					}
				}
			]
		};
}

//获取数组下标
function getArrayIndex(value,arr) {
    var i = arr.length;
    while (i--) {
        if (arr[i] === value) {
            return i;
        }
    }
    return -1;
}


//分时初始化
function mInit(vue,data) {
	var mId = document.getElementById('m-line');
	mChart = echarts.init(mId)
	mOption = initMOption(vue,data)
	mChart.setOption(mOption)
	return mChart;
}

//分时数据追加
function mAppend(data) {
	// 必须判断，否则先执行追加会报错
	if('undefined' == typeof mOption){
		return false
	}
	// 数据格式处理
	data = toNumber(data);
	var curIndex = getArrayIndex(data[0],mOption.xAxis[0].data)
	if (curIndex==-1) {
		curIndex = mOption.xAxis[0].data.length
	}
	mOption.series[0].data[curIndex] = data[1] //最新价
	mOption.series[1].data[curIndex] = data[2] //均价
	mOption.series[2].data[curIndex] = data[1] //价格
	mOption.series[3].data[curIndex] = data[3] //成交量
	mChart.setOption(mOption,true)
}

// 一维数组，排除第一个（时间），其他数值转成数字
function toNumber(arr) {
	var result = [arr[0]];
	for (var i = 1; i < arr.length; i++) {
		result.push(Number(arr[i]))
	}
	return result;
}
//k线初始化
function kInit(vue,data) {
	var kId = document.getElementById('k-line')
	kChart = echarts.init(kId)
	kOption = initKOption(vue,data)
	kChart.setOption(kOption)
	// 全局间推dataZoom位置
	kChart.on('dataZoom',function(event){
	   if(event.batch){
		   dataZoom_k_start=event.batch[0].start;
		   dataZoom_k_end=event.batch[0].end;
	   }else{
		   dataZoom_k_start=event.start;
		   dataZoom_k_end=event.end;
	   };
	});
	return kChart;
}
// k线提示框显示和隐藏
function kShowTooltip(is_show) {
	// 获取配置
	var option = kChart.getOption();
	if (is_show) {
		// 是否停止组件的功能
		option.dataZoom[0].disabled = true
	}
	else {
		option.dataZoom[0].disabled = false
	}
	option.tooltip[0].show = is_show
	kChart.setOption(option)
}
// k线数据追加 或最新点跳动
function kAppend(data) {
	// 必须判断，否则先执行追加会报错
	if('undefined' == typeof kOption || kOption==null){
		return false
	}
	// 数据格式处理
	data = toNumber(data);
	var datas = kOption.series[0].data;
	var times = kOption.xAxis[0].data;
	var vols = kOption.series[5].data;
	// 删除数组元素，并返回被删除的值
	var newTimes = data.splice(0, 1)[0];
	var is_exist = times.indexOf(newTimes)>-1;
	// 追加
	if (!is_exist) {
		datas[datas.length] = data
		times[times.length] = newTimes
		vols[vols.length] = data[4]
	}
	// 最后一点跳动
	else {
		datas[datas.length-1] = data
		// times[times.length-1] = newTimes
		vols[vols.length-1] = data[4]
	}
	var kdata = {
		datas:datas,
		times:times,
		vols:vols
	}
	var ma5 = calculateMA(5,kdata)
	var ma10 = calculateMA(10,kdata)
	var ma20 = calculateMA(20,kdata)
	var ma30 = calculateMA(30,kdata)
	var macd = calcMACD(12,26,9,kdata.datas,1)
	kOption.xAxis[0].data = kdata.times //x轴 增加刻度 ok
	kOption.xAxis[1].data = kdata.times //x轴 增加刻度 ok
	kOption.xAxis[2].data = kdata.times //x轴 增加刻度 ok
	kOption.series[0].data = kdata.datas //K线周期图表 ok
	kOption.series[1].data = ma5 //MA5
	kOption.series[2].data = ma10 //MA10
	kOption.series[3].data = ma20 //MA20
	kOption.series[4].data = ma30 //MA30
	kOption.series[5].data = kdata.vols //成交量
	kOption.series[6].data = macd.macd //MACD
	kOption.series[7].data = macd.dif //DIF
	kOption.series[8].data = macd.dea //DEA
	if (dataZoom_k_start != undefined && dataZoom_k_end != undefined) {
		kOption.dataZoom[0].start = dataZoom_k_start; // dataZoom开始位置
		kOption.dataZoom[0].end = dataZoom_k_end; // dataZoom结束位置
	}
	// 设置
	kChart.setOption(kOption);
	// 设置日均值
	document.getElementById("k-ma5").innerHTML = ma5[ma5.length-1];
	document.getElementById("k-ma10").innerHTML = ma10[ma10.length-1];
	document.getElementById("k-ma20").innerHTML = ma20[ma20.length-1];
	document.getElementById("k-ma30").innerHTML = ma30[ma30.length-1];
	return true;
}

export { mInit,mAppend,kInit,kAppend,kShowTooltip }



// WEBPACK FOOTER //
// ./src/plugins/echarts.js